const COMPACT_NUMBER_FORMATTER = new Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 1,
});

const TOKEN_LIKE_PATTERN =
  /[\u4e00-\u9fff]|[A-Za-z0-9_]+(?:'[A-Za-z0-9_]+)?|[^\sA-Za-z0-9_\u4e00-\u9fff]/g;

export function estimateTokenCount(text: string): number {
  const trimmed = text.trim();
  if (!trimmed) {
    return 0;
  }

  const matches: string[] = trimmed.match(TOKEN_LIKE_PATTERN) || [];

  return matches.reduce((total, tokenLike) => {
    if (/^[A-Za-z0-9_]+(?:'[A-Za-z0-9_]+)?$/.test(tokenLike)) {
      if (tokenLike.length > 12) {
        return total + Math.ceil(tokenLike.length / 4);
      }

      return total + 1;
    }

    return total + 1;
  }, 0);
}

export function formatTokenCount(count: number): string {
  const unit = count === 1 ? "token" : "tokens";
  return `${COMPACT_NUMBER_FORMATTER.format(count)} ${unit}`;
}
